import { DeviceFunctionalAspectType } from "@solid/client/generated/graphql";

export const cachedDeviceTypes = [
  { type: DeviceFunctionalAspectType.Media },
  { type: DeviceFunctionalAspectType.Avatar },
  { type: DeviceFunctionalAspectType.Sensor },
  { type: DeviceFunctionalAspectType.Gateway }
];
